import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { onActions } from '../../utils/helpers/redux.helper';
import {
  ActionsEnum,
  authenticated,
  login,
  logout,
  setRedirectPath,
  unauthenticated,
  updateTokens,
} from './auth-data.actions';

@Injectable()
export class AuthDataDispatcher {
  constructor(private _store: Store<any>, private _actions: Actions) {}

  authenticated() {
    this._store.dispatch(authenticated());
  }

  login(username: string, pw: string, accountId?: string): Observable<any> {
    const dispatchId: string = v4();

    this._store.dispatch(login(dispatchId, username, pw, accountId));

    return onActions(
      this._actions,
      [ActionsEnum.LOGIN_SUCCESS, ActionsEnum.LOGIN_ERROR],
      dispatchId
    );
  }

  logout(isForced: boolean = false, redirectPath: string = null) {
    this._store.dispatch(logout(isForced, redirectPath));
  }

  unauthenticated(userId: string, accountId: string, isForced: boolean) {
    this._store.dispatch(unauthenticated(userId, accountId, isForced));
  }

  updateTokens(accessToken: string, refreshToken: string) {
    this._store.dispatch(updateTokens(accessToken, refreshToken));
  }

  setRedirectPath(redirectPath: string) {
    this._store.dispatch(setRedirectPath(redirectPath));
  }
}
